<template>
  <v-dialog
    v-model="mutableShowConfirmBox"
    persistent
    :width="456"
  >
    <v-card :data-cy="dataCy.modals.confirmModal.card">
      <v-card-title>
        {{ $t(titleKey) }}
      </v-card-title>
      <v-divider />
      <v-card-text class="py-4">
        {{ $t(contentKey) }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="hide"
        >
          {{ $t('forms.btn.cancel') }}
        </v-btn>
        <v-btn
          :data-cy="dataCy.modals.confirmModal.buttons.confirm"
          color="primary"
          @click="$emit('destroyModal')"
        >
          {{ $t('forms.btn.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { modals } from '@/aq-data-cy.json';

export default {
    props: {
        showConfirmBox: {
            type: Boolean,
            default: false,
        },
        titleKey: {
            type: String,
            default: 'forms.labels.confirmUnsavedChangesTitle',
        },
        contentKey: {
            type: String,
            default: 'forms.noSaveQuit',
        },
    },
    data() {
        return {
            mutableShowConfirmBox: null,
        };
    },
    computed: {
        dataCy() {
            return {
                modals,
            };
        },
    },
    watch: {
        showConfirmBox: {
            handler() {
                this.mutableShowConfirmBox = this.showConfirmBox;
            },
            immediate: true,
        },
    },
    methods: {
        hide() {
            this.mutableShowConfirmBox = false;
            this.$emit('hide', this.mutableShowConfirmBox);
        },
    },
};
</script>
